import styled from "styled-components";

export const Styles = styled.div`
  padding: 0 130px 100px;
  direction: rtl;

  @media screen and (max-width: 992px) {
    padding: 0 40px 80px;
  }

  @media screen and (max-width: 600px) {
    padding: 0 20px 70px;
  }

  .location-section {
    padding: 40px;
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);

    @media screen and (max-width: 600px) {
      padding: 25px 16px;
    }
  }

  .location-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 30px;
    margin-bottom: 25px;

    @media screen and (max-width: 768px) {
      display: block;
    }

    .location-label {
      margin-bottom: 7px;
      color: #5b616e;
      font-family: IRANSans;
      font-size: 13px;
      font-weight: 600;
    }

    h2 {
      margin: 0;
      color: #1a1a1c;
      font-family: IRANSans;
      font-size: 28px;
      line-height: 1.5;
    }

    p {
      max-width: 420px;
      margin: 0;
      color: #5b616e;
      font-family: IRANSans;
      font-size: 15px;
      line-height: 1.8;

      @media screen and (max-width: 768px) {
        margin-top: 12px;
      }
    }
  }

  .map-frame {
    position: relative;
    height: 320px;
    overflow: hidden;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 10px;

    @media screen and (max-width: 600px) {
      height: 260px;
    }

    .map {
      width: 100%;
      height: 100%;
      z-index: 0;
    }

    .map-lock {
      position: absolute;
      inset: 0;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding: 20px;
      color: #ffffff;
      background: rgba(26, 26, 28, 0.42);
      border: 0;
      cursor: pointer;
      font-family: IRANSans;
      font-size: 15px;
      font-weight: 600;
    }
  }

  .exchange-map-marker {
    background: transparent;
    border: none;
  }

  .exchange-map-marker-dot {
    display: block;
    width: 22px;
    height: 22px;
    background: #1a1a1c;
    border: 4px solid #ffffff;
    border-radius: 50% 50% 50% 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);
    transform: rotate(-45deg);
  }

  .navigation-apps {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 14px;
    margin-top: 25px;
  }

  .navigation-card {
    display: flex;
    flex-direction: column;
    width: fit-content;
    overflow: hidden;
    background: #f5f6f7;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 12px;

    a {
      display: flex;
      flex: 1;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 9px;
      padding: 16px 14px;
      color: #1a1a1c;
      font-family: IRANSans;
      font-size: 14px;
      font-weight: 600;
      text-align: center;
      text-decoration: none;
      transition: background 0.2s;

      &:hover {
        background: rgba(0, 0, 0, 0.04);
      }

      img {
        width: 32px;
        height: 32px;
        object-fit: contain;
      }
    }

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      padding: 10px 12px;
      color: #2f70b5;
      background: transparent;
      border: 0;
      border-top: 1px solid rgba(0, 0, 0, 0.1);
      cursor: pointer;
      font-family: IRANSans;
      font-size: 12px;
      font-weight: 600;

      &:hover {
        background: rgba(0, 0, 0, 0.04);
      }

      .share-icon {
        font-size: 17px;
      }
    }
  }
`;
